import { useSelector } from 'react-redux';
import { LayoutType } from 'signup-components/types';
import { Step } from 'signup-constants/Step';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { LoadingKey } from '../app-active-loading/LoadingKey';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useMessage } from '../messaging/useMessage';
import { getActiveError } from '../store/error/selectors';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { getStepConfig } from '../views/getStepConfig';
import { useCurrentStep } from './useCurrentStep';
import { useIsFramedCentredModalStep } from './useIsFramedCerntredModalStep';
import { getShouldShowSidePanel } from '../utils/getShouldShowSidePanel';
import { getIsMobile } from '../utils/deviceUtils';
import { useIsSU0004Variation } from './useIsSU0004Variation';
export const useLayoutTemplate = () => {
  const postAccountCreationSteps = useSelector(getPostAccountCreationSteps);
  const {
    currentStep
  } = useCurrentStep();
  const activeError = useSelector(getActiveError);
  const step = activeError || currentStep;
  const stepConfig = getStepConfig(step);
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const {
    isFramedCentredModalStep
  } = useIsFramedCentredModalStep();
  const showMessagingAboveContent = stepConfig && stepConfig.showMessagingAboveContent;
  const {
    shouldDisplayMessaging
  } = useMessage();
  const isMobile = getIsMobile();
  const shouldShowSidePanel = getShouldShowSidePanel();
  const isAssignedToSU0004 = useIsSU0004Variation();
  let layoutType = shouldDisplayMessaging && !showMessagingAboveContent ? LayoutType.TwoColumn : (stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.layoutType) || getFlowConfig().getLayoutType();
  if (layoutType === LayoutType.SidePanel && (isMobile || activeError)) {
    layoutType = LayoutType.CentredStep;
  }
  const activeLoading = useSelector(getActiveLoading);
  const isPostAccountCreationStep = postAccountCreationSteps.includes(currentStep);
  const isNotVerificationLoading = activeLoading !== LoadingKey.InitiateVerificationRequest;
  const stepConfigHasProgressBar = stepConfig && stepConfig.stepKey && !stepConfig.hideProgressBar;
  let shouldShowProgressBar = isNotVerificationLoading && !activeError && stepConfigHasProgressBar;
  if (shouldShowSidePanel) {
    shouldShowProgressBar = false;
  }
  if (isFramedCentredModalStep) {
    return {
      layoutType: LayoutType.FramedCentredModalStep,
      shouldShowProgressBar
    };
  }
  if (activeLoading) {
    return {
      layoutType: LayoutType.CentredStep,
      shouldShowProgressBar
    };
  }
  if (isPostAccountCreationStep && !isInstanceOfSignupEmbedder && layoutType === LayoutType.CentredStep) {
    return {
      layoutType,
      shouldShowProgressBar
    };
  }
  if (isAssignedToSU0004 && currentStep !== Step.LandingPage && !activeError) {
    return {
      layoutType: LayoutType.CentredStep,
      shouldShowProgressBar: false
    };
  }
  const shouldShowSidePanelForStep = stepConfig && stepConfig.layoutType ? stepConfig.layoutType === LayoutType.SidePanel : false;
  if (shouldShowSidePanel && shouldShowSidePanelForStep && !activeError) {
    return {
      layoutType: LayoutType.SidePanel,
      shouldShowProgressBar
    };
  }
  return {
    layoutType,
    shouldShowProgressBar
  };
};